import request from "../utils/request"

export function fetchActivityCampaigns() {
  return request({
    url: "/admin/activity/campaigns",
    method: "get"
  })
}

export function fetchActivityStats(params = {}) {
  return request({
    url: "/admin/activity/stats",
    method: "get",
    params
  })
}

export function fetchActivityEntries(params = {}) {
  return request({
    url: "/admin/activity/entries",
    method: "get",
    params
  })
}

export function reviewActivityEntry(id, data = {}) {
  return request({
    url: `/admin/activity/entries/${id}/review`,
    method: "post",
    data
  })
}

export function fetchActivityEntryLogs(id) {
  return request({
    url: `/admin/activity/entries/${id}/logs`,
    method: "get"
  })
}

export function fetchDrawState(params = {}) {
  return request({
    url: "/admin/activity/draw",
    method: "get",
    params
  })
}

export function runActivityDraw(campaignId) {
  return request({
    url: "/admin/activity/draw",
    method: "post",
    params: { campaignId }
  })
}

export function revokeActivityDraw(campaignId) {
  return request({
    url: "/admin/activity/draw",
    method: "delete",
    params: { campaignId }
  })
}

export function confirmActivityDraw(campaignId) {
  return request({
    url: "/admin/activity/draw/confirm",
    method: "post",
    params: { campaignId }
  })
}
